import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'mlp-ng-tile',
    templateUrl: './tile.component.html',
    styleUrls: ['./tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TileSharedComponent {
    @Input() active = false;
    @Input() class: string;
    get faIcon(): string { return (this.active) ? 'check-1' : 'add'; }

}
